import pdfMake from 'pdfmake/build/pdfmake'
import font from 'pdfmake/build/vfs_fonts'
import moment from 'moment';

import {
  bidInfo,
  charges,
  credibility,
  images,
  information,
  sectionHeader,
  styles,
  tasks,
} from './index';

import {
  header,
} from '../core';

export const generateBidPDF = (bid, bidTasks, companyInfo, client) => {
  const dd = {
    content: [],
    images: images,
    styles: styles,
    defaultStyle: { columnGap: 20 },
  };

  dd.content.push(header("BID", companyInfo));
  dd.content.push(bidInfo(bid, bidTasks, client));
  dd.content.push(information(bid));
  dd.content.push(tasks(bidTasks));
  dd.content.push(charges(bidTasks));
  dd.content.push(credibility(bid));

  pdfMake.vfs = font.pdfMake.vfs;
  const pdf = pdfMake.createPdf(dd);

  return pdf;
}



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/generateBidPDF.js